//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// week-in-review-scrubber imports
import { IHourLabelsProps } from "./WeekInReviewScrubber.d";
import * as s from "./WeekInReviewScrubber.styles";
// material-ui
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { IconButton } from "@material-ui/core";
import { PlayArrow, Pause } from "@material-ui/icons";

// legend with little dots indicating colors
export const Legend = () => (
  <div style={s.legendContainer}>
    <div style={s.legendDotFocus} />
    <div style={s.legendLabel}>Focus Time</div>
    <div style={s.legendDotMeetings} />
    <div style={s.legendLabel}>Meetings</div>
    <div style={s.legendDotOther} />
    <div style={s.legendLabel}>Other</div>
  </div>
);

// vertical labels for start/end of working hours
export const HourLabels = ({ overallWorkingHours }: IHourLabelsProps) => {
  // time labels are hard to get accurate...
  const startLabel = overallWorkingHours.start.label;
  const startNeedsOffset = overallWorkingHours.start.needsOffset;
  const endLabel = overallWorkingHours.end.label;
  const endNeedsOffset = overallWorkingHours.end.needsOffset;

  return (
    <div style={s.timeLabelColumn}>
      <div style={{ marginTop: startNeedsOffset ? 10 : 0 }}>{startLabel}</div>
      <div style={{ marginTop: endNeedsOffset ? -10 : 0 }}>{endLabel}</div>
    </div>
  );
};

// label for the scubber
export const ScrubberLabel = ({ weekSnapshotIndex }: { weekSnapshotIndex: number }) => {
  const labels = [
    "Start of the week",
    "As of Monday evening",
    "As of Tuesday evening",
    "As of Wednesday evening",
    "As of Thursday evening",
    "End of the week",
  ];
  return <div style={s.sliderLabel}>{labels[weekSnapshotIndex]}</div>;
};

interface IPlayPauseButtonProps extends WithStyles<typeof s.styles> {
  onClick: () => void;
  isAnimating: boolean;
}

// play-pause button
export const PlayPauseButtonCmpt = (props: IPlayPauseButtonProps) => (
  <IconButton {...s.playPauseButton} onClick={props.onClick}>
    {props.isAnimating ? (
      <Pause className={props.classes.pauseIcon} />
    ) : (
      <PlayArrow className={props.classes.playIcon} />
    )}
  </IconButton>
);

export const PlayPauseButton = withStyles(s.styles)(PlayPauseButtonCmpt);
